(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === "object" && typeof module === "object")
    module.exports = factory();
  else if (typeof define === "function" && define.amd) define([], factory);
  else {
    var a = factory();
    for (var i in a) (typeof exports === "object" ? exports : root)[i] = a[i];
  }
})(self, () => {
  return /******/ (() => {
    // webpackBootstrap
    /******/ "use strict";
    /******/ // The require scope
    /******/ var __webpack_require__ = {};
    /******/
    /************************************************************************/
    /******/ /* webpack/runtime/define property getters */
    /******/ (() => {
      /******/ // define getter functions for harmony exports
      /******/ __webpack_require__.d = (exports, definition) => {
        /******/ for (var key in definition) {
          /******/ if (
            __webpack_require__.o(definition, key) &&
            !__webpack_require__.o(exports, key)
          ) {
            /******/ Object.defineProperty(exports, key, {
              enumerable: true,
              get: definition[key],
            });
            /******/
          }
          /******/
        }
        /******/
      };
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/hasOwnProperty shorthand */
    /******/ (() => {
      /******/ __webpack_require__.o = (obj, prop) =>
        Object.prototype.hasOwnProperty.call(obj, prop);
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/make namespace object */
    /******/ (() => {
      /******/ // define __esModule on exports
      /******/ __webpack_require__.r = (exports) => {
        /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
          /******/ Object.defineProperty(exports, Symbol.toStringTag, {
            value: "Module",
          });
          /******/
        }
        /******/ Object.defineProperty(exports, "__esModule", { value: true });
        /******/
      };
      /******/
    })();
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
    // ESM COMPAT FLAG
    __webpack_require__.r(__webpack_exports__);

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, {
      AlgoSigner: () => /* reexport */ AlgoSigner,
      algorand: () => /* reexport */ algorand,
    }); // CONCATENATED MODULE: ../common/src/errors.ts

    class RequestError {
      constructor(message, code, data) {
        this.name = "AlgoSignerRequestError";
        this.message = message;
        this.code = code;
        this.data = data;
        Error.captureStackTrace(this, RequestError);
      }
    }
    // Maximum amount of transactions supported on a single group
    RequestError.MAX_GROUP_SIZE = 16;
    RequestError.None = new RequestError("", 0);
    RequestError.Undefined = new RequestError(
      "An undefined error occurred.",
      4000
    );
    RequestError.UserRejected = new RequestError(
      "The extension user does not authorize the request.",
      4001
    );
    RequestError.EnableRejected = (data) =>
      new RequestError(
        "The extension user does not authorize the request.",
        4001,
        data
      );
    RequestError.SiteNotAuthorizedByUser = new RequestError(
      "The extension user has not authorized requests from this website.",
      4100
    );
    RequestError.NoMnemonicAvailable = (address) =>
      new RequestError(
        `The user does not possess the required private key to sign with for address: "${address}".`,
        4100
      );
    RequestError.NoAccountMatch = (address, ledger) =>
      new RequestError(
        `No matching account found on AlgoSigner for address "${address}" on network ${ledger}.`,
        4100
      );
    RequestError.UnsupportedLedger = new RequestError(
      "The provided ledger is not supported.",
      4200
    );
    RequestError.PendingTransaction = new RequestError(
      "Another query processing",
      4201
    );
    RequestError.LedgerMultipleGroups = new RequestError(
      "Ledger hardware device signing is only available for one transaction group at a time.",
      4201
    );
    RequestError.TooManyTransactions = new RequestError(
      `AlgoSigner does not support signing more than ${RequestError.MAX_GROUP_SIZE} transactions at a time.`,
      4201
    );
    RequestError.AlgoSignerNotInitialized = new RequestError(
      "AlgoSigner was not initialized properly beforehand.",
      4202
    );
    RequestError.InvalidFields = (data) =>
      new RequestError(
        "Validation failed for transaction due to invalid properties.",
        4300,
        data
      );
    RequestError.InvalidTransactionStructure = (data) =>
      new RequestError(
        "Validation failed for transaction due to invalid structure.",
        4300,
        data
      );
    RequestError.InvalidSignTxnsFormat = new RequestError(
      "Please provide an array of either valid transaction objects or nested arrays of valid transaction objects.",
      4300
    );
    RequestError.InvalidPostTxnsFormat = new RequestError(
      "Please provide either an array of signed transactions or an array of groups of signed transactions.",
      4300
    );
    RequestError.PostValidationFailed = (reason) =>
      new RequestError(
        "There was a problem validating the transaction(s). The reasons are provided in the 'data' property.",
        4300,
        reason
      );
    RequestError.CantMatchMsigSigners = (info) =>
      new RequestError(
        `AlgoSigner does not currently possess one of the requested signers for this multisig transaction: ${info}.`,
        4300
      );
    RequestError.InvalidSignerAddress = (address) =>
      new RequestError(
        `Signers array contains the invalid address "${address}"`,
        4300
      );
    RequestError.MsigSignersMismatch = new RequestError(
      "The 'signers' array contains addresses that aren't subaccounts of the requested multisig account.",
      4300
    );
    RequestError.NoMsigSingleSigner = new RequestError(
      "When a single-address 'signers' is provided with no 'msig' alongside it, it must match either the transaction sender or (if provided) the 'authAddr'",
      4300
    );
    RequestError.NoMsigMultipleSigners = new RequestError(
      "Multiple (1+) 'signers' should only be used alongside 'msig' transactions to specify which subaccounts to sign with.",
      4300
    );
    RequestError.InvalidSignedTxn = new RequestError(
      "The signed transaction provided ('{ stxn:... }') could not be parsed.",
      4300
    );
    RequestError.NonMatchingSignedTxn = new RequestError(
      "The signed transaction provided ('{ stxn:... }') doesn't match the corresponding unsigned transaction ('{ txn:... }').",
      4300
    );
    RequestError.SignedTxnWithSigners = new RequestError(
      "A signed transaction ('{ stxn:... }') must only be provided for reference transactions ('{ signers: [] }').",
      4300
    );
    RequestError.NoTxsToSign = new RequestError(
      "There are no transactions to sign as the provided ones are for reference-only ('{ signers: [] }').",
      4300
    );
    RequestError.InvalidStructure = new RequestError(
      "The provided transaction object doesn't adhere to the correct structure.",
      4300
    );
    RequestError.InvalidMsigStructure = new RequestError(
      "The provided multisig data doesn't adhere to the correct structure.",
      4300
    );
    RequestError.InvalidMsigValues = (reason) =>
      new RequestError(
        `The provided multisig data has invalid values: ${reason}.`,
        4300
      );
    RequestError.InvalidMsigAddress = (address) =>
      new RequestError(`The address '${address}' is invalid.`, 4300);
    RequestError.MsigAuthAddrMismatch = new RequestError(
      "The provided 'authAddr' doesn't match the requested multisig account.",
      4300
    );
    RequestError.InvalidAuthAddress = (address) =>
      new RequestError(
        `'authAddr' contains the invalid address "${address}"`,
        4300
      );
    RequestError.IncompleteOrDisorderedGroup = new RequestError(
      "The provided group ID does not match the provided transactions. This usually means the transaction group is incomplete or presented in a different order than when it was created.",
      4300
    );
    RequestError.MultipleTxsRequireGroup = new RequestError(
      "If signing multiple transactions, they need to belong to a same group.",
      4300
    );
    RequestError.MismatchingGroup = new RequestError(
      "All transactions provided in a same group need to have matching group IDs.",
      4300
    );
    RequestError.NoDifferentLedgers = new RequestError(
      "All transactions need to belong to the same ledger.",
      4300
    );
    RequestError.PartiallySuccessfulPost = (successTxnIDs, data) =>
      new PostError(
        successTxnIDs,
        "Some of the groups of transactions were unable to be posted. The reason for each unsuccessful group is in it's corresponding position inside the 'data' array.",
        4400,
        data
      );
    RequestError.PostConfirmationFailed = new RequestError(
      "The transaction(s) were succesfully sent to the network, but there was an issue while waiting for confirmation. Please verify that they were commited to the network before trying again.",
      4400
    );
    RequestError.SigningError = (code, data) =>
      new RequestError(
        "There was a problem signing the transaction(s).",
        code,
        data
      );
    class PostError extends RequestError {
      constructor(successTxnIDs, message, code, data) {
        super(message, code, data);
        this.successTxnIDs = successTxnIDs;
      }
    } // CONCATENATED MODULE: ../common/src/messaging/types.ts

    const JSONRPC_VERSION = "2.0";
    /* eslint-disable no-unused-vars */
    var JsonRpcMethod;
    (function (JsonRpcMethod) {
      // dApp methods
      JsonRpcMethod["Heartbeat"] = "heartbeat";
      JsonRpcMethod["Authorization"] = "authorization";
      JsonRpcMethod["EnableAuthorization"] = "enable-authorization";
      JsonRpcMethod["AuthorizationAllow"] = "authorization-allow";
      JsonRpcMethod["AuthorizationDeny"] = "authorization-deny";
      JsonRpcMethod["SignAllowWalletTx"] = "sign-allow-wallet-tx";
      JsonRpcMethod["SignDeny"] = "sign-deny";
      JsonRpcMethod["SignWalletTransaction"] = "sign-wallet-transaction";
      JsonRpcMethod["SendTransaction"] = "send-transaction";
      JsonRpcMethod["PostTransactions"] = "post-txns";
      JsonRpcMethod["Algod"] = "algod";
      JsonRpcMethod["Indexer"] = "indexer";
      JsonRpcMethod["Accounts"] = "accounts";
      // UI methods
      JsonRpcMethod["CreateWallet"] = "create-wallet";
      JsonRpcMethod["DeleteWallet"] = "delete-wallet";
      JsonRpcMethod["CreateAccount"] = "create-account";
      JsonRpcMethod["SaveAccount"] = "save-account";
      JsonRpcMethod["ImportAccount"] = "import-account";
      JsonRpcMethod["DeleteAccount"] = "delete-account";
      JsonRpcMethod["GetSession"] = "get-session";
      JsonRpcMethod["Login"] = "login";
      JsonRpcMethod["Logout"] = "logout";
      JsonRpcMethod["ClearCache"] = "clear-cache";
      JsonRpcMethod["AccountDetails"] = "account-details";
      JsonRpcMethod["Transactions"] = "transactions";
      JsonRpcMethod["AssetDetails"] = "asset-details";
      JsonRpcMethod["AssetsAPIList"] = "assets-api-list";
      JsonRpcMethod["AssetsVerifiedList"] = "assets-verified-list";
      JsonRpcMethod["SignSendTransaction"] = "sign-send-transaction";
      JsonRpcMethod["ChangeLedger"] = "change-ledger";
      JsonRpcMethod["SaveNetwork"] = "save-network";
      JsonRpcMethod["CheckNetwork"] = "check-network";
      JsonRpcMethod["DeleteNetwork"] = "delete-network";
      JsonRpcMethod["GetLedgers"] = "get-ledgers";
      JsonRpcMethod["GetContacts"] = "get-contacts";
      JsonRpcMethod["SaveContact"] = "save-contact";
      JsonRpcMethod["DeleteContact"] = "delete-contact";
      JsonRpcMethod["GetAliasedAddresses"] = "get-aliased-addresses";
      JsonRpcMethod["GetNamespaceConfigs"] = "get-namespace-configs";
      JsonRpcMethod["ToggleNamespaceConfig"] = "toggle-namespace-config";
      JsonRpcMethod["GetGovernanceAddresses"] = "get-governance-addresses";
      JsonRpcMethod["GetEnableAccounts"] = "get-enable-accounts";
      // Ledger Device Methods
      JsonRpcMethod["LedgerSaveAccount"] = "ledger-save-account";
      JsonRpcMethod["LedgerLinkAddress"] = "ledger-link-address";
      JsonRpcMethod["LedgerGetSessionTxn"] = "ledger-get-session-txn";
      JsonRpcMethod["LedgerSendTxnResponse"] = "ledger-send-txn-response";
      JsonRpcMethod["LedgerSignTransaction"] = "ledger-sign-transaction";
    })(JsonRpcMethod || (JsonRpcMethod = {}));
    var MessageSource;
    (function (MessageSource) {
      MessageSource["Extension"] = "extension";
      MessageSource["DApp"] = "dapp";
      MessageSource["Router"] = "router";
      MessageSource["UI"] = "ui";
    })(MessageSource || (MessageSource = {})); // CONCATENATED MODULE: ../common/src/messaging/jsonrpc.ts

    // In TS, you cannot define static properties on interfaces
    // More in https://stackoverflow.com/questions/13955157/how-to-define-static-property-in-typescript-interface
    class JsonRpc /*implements IJsonRpc*/ {
      static getBody(method, params) {
        return {
          jsonrpc: JSONRPC_VERSION,
          method: method,
          params: params,
          id: "xxxxxxxxxxxxxxx".replace(/[x]/g, () => {
            return ((Math.random() * 16) | 0).toString(16);
          }),
        };
      }
    } // CONCATENATED MODULE: ./src/messaging/api.ts

    class MessageApi {
      constructor() {
        this.mc = new MessageChannel();
      }
      listen(handler) {
        this.mc.port1.onmessage = handler;
      }
      send(body, source = MessageSource.DApp) {
        const msg = {
          source: source,
          body: body,
        };
        window.postMessage(msg, window.location.origin, [this.mc.port2]);
      }
    } // CONCATENATED MODULE: ./src/messaging/handler.ts

    class OnMessageHandler {
      static promise(resolve, reject) {
        return (event) => {
          if (event.data.error) {
            reject(event.data.error);
          } else if (event.data.response) {
            resolve(event.data.response);
          } else {
            reject(RequestError.Undefined);
          }
        };
      }
    } // CONCATENATED MODULE: ./src/messaging/builder.ts

    class MessageBuilder {
      static promise(method, params, error = RequestError.None) {
        return new Promise((resolve, reject) => {
          if (error == RequestError.None) {
            const api = new MessageApi();
            api.listen(OnMessageHandler.promise(resolve, reject));
            api.send(JsonRpc.getBody(method, params));
          } else {
            reject(error);
          }
        });
      }
    } // CONCATENATED MODULE: ../common/src/types.ts

    var Ledger;
    (function (Ledger) {
      Ledger["TestNet"] = "TestNet";
      Ledger["MainNet"] = "MainNet";
    })(Ledger || (Ledger = {}));
    var OptsKeys;
    (function (OptsKeys) {
      OptsKeys["ARC01Return"] = "AlgoSigner_arc01";
      OptsKeys["sendTxns"] = "AlgoSigner_send";
    })(OptsKeys || (OptsKeys = {}));
    var Namespace;
    (function (Namespace) {
      Namespace["AlgoSigner_Contacts"] = "AlgoSigner_Contacts";
      Namespace["AlgoSigner_Accounts"] = "AlgoSigner_Accounts";
      Namespace["NFD"] = "NFD";
      Namespace["ANS"] = "ANS";
    })(Namespace || (Namespace = {})); // CONCATENATED MODULE: ../common/src/runtime/validation.ts

    function diff(a, b) {
      const result = [];
      for (let i = 0; i < a.length; i++) {
        if (b.indexOf(a[i]) === -1) {
          result.push(a[i]);
        }
      }
      return result;
    }
    class Validation {
      requiredArgs(required, input) {
        const d = diff(required, input);
        if (d.length > 0) return false;
        return true;
      }
    } // CONCATENATED MODULE: ../common/src/runtime/runtime.ts

    class Runtime extends Validation {} // CONCATENATED MODULE: ./src/fn/task.ts

    class Task extends Runtime {
      static validateFormat(transactionsOrGroups) {
        const formatError = RequestError.InvalidSignTxnsFormat;
        // We check for empty arrays
        if (
          !Array.isArray(transactionsOrGroups) ||
          !transactionsOrGroups.length
        )
          throw formatError;
        transactionsOrGroups.forEach((txOrGroup) => {
          // We check for no null values and no empty nested arrays
          if (
            txOrGroup === null ||
            txOrGroup === undefined ||
            (!Array.isArray(txOrGroup) &&
              typeof txOrGroup === "object" &&
              (!txOrGroup.txn || (txOrGroup.txn && !txOrGroup.txn.length))) ||
            (Array.isArray(txOrGroup) &&
              (!txOrGroup.length ||
                (txOrGroup.length && !txOrGroup.every((tx) => tx !== null))))
          )
            throw formatError;
        });
      }
      connect() {
        return MessageBuilder.promise(JsonRpcMethod.Authorization, {});
      }
      enable(opts, error = RequestError.None) {
        const params = Object.assign({}, opts);
        return MessageBuilder.promise(
          JsonRpcMethod.EnableAuthorization,
          params,
          error
        );
      }
      accounts(params, error = RequestError.None) {
        return MessageBuilder.promise(JsonRpcMethod.Accounts, params, error);
      }
      send(params, error = RequestError.None) {
        return MessageBuilder.promise(
          JsonRpcMethod.SendTransaction,
          params,
          error
        );
      }
      algod(params, error = RequestError.None) {
        return MessageBuilder.promise(JsonRpcMethod.Algod, params, error);
      }
      indexer(params, error = RequestError.None) {
        return MessageBuilder.promise(JsonRpcMethod.Indexer, params, error);
      }
      subscribe(eventName, callback) {
        Task.subscriptions[eventName] = callback;
      }
      /**
       * @param transactionsOrGroups array or nested array of grouped transaction objects
       * @returns array or nested array of signed transactions
       */
      signTxn(transactionsOrGroups, error = RequestError.None) {
        Task.validateFormat(transactionsOrGroups);
        const params = {
          transactionsOrGroups: transactionsOrGroups,
        };
        return MessageBuilder.promise(
          JsonRpcMethod.SignWalletTransaction,
          params,
          error
        );
      }
      /**
       * @param transactionsOrGroups array or nested array of grouped transaction objects
       * @param opts optional parameters passed to the function
       * @returns array or nested array of signed transactions
       */
      signTxns(transactionsOrGroups, opts, error = RequestError.None) {
        Task.validateFormat(transactionsOrGroups);
        const params = {
          transactionsOrGroups: transactionsOrGroups,
          opts: Object.assign({ [OptsKeys.ARC01Return]: true }, opts),
        };
        return MessageBuilder.promise(
          JsonRpcMethod.SignWalletTransaction,
          params,
          error
        );
      }
      /**
       * @param transactionsOrGroups array or nested array of grouped transaction objects
       * @param opts optional parameters passed to the function
       * @returns array or nested array of confirmed transactions sent to the network
       */
      signAndPostTxns(transactionsOrGroups, opts, error = RequestError.None) {
        Task.validateFormat(transactionsOrGroups);
        const params = {
          transactionsOrGroups: transactionsOrGroups,
          opts: Object.assign(
            { [OptsKeys.ARC01Return]: true, [OptsKeys.sendTxns]: true },
            opts
          ),
        };
        return MessageBuilder.promise(
          JsonRpcMethod.SignWalletTransaction,
          params,
          error
        );
      }
      /**
       * @param stxns array or nested array of grouped signed transaction
       * @returns array or nested array of confirmed transactions sent to the network
       */
      postTxns(stxns, error = RequestError.None) {
        return MessageBuilder.promise(
          JsonRpcMethod.PostTransactions,
          { stxns },
          error
        );
      }
    }
    Task.subscriptions = {}; // CONCATENATED MODULE: ../common/src/logging.ts

    ///
    // Central error handling.
    ///
    var LogLevel;
    (function (LogLevel) {
      /* eslint-disable no-unused-vars */
      LogLevel[(LogLevel["None"] = 0)] = "None";
      LogLevel[(LogLevel["Normal"] = 1)] = "Normal";
      LogLevel[(LogLevel["Debug"] = 2)] = "Debug";
      LogLevel[(LogLevel["Extensive"] = 3)] = "Extensive";
    })(LogLevel || (LogLevel = {}));
    class Logging {
      constructor() {
        // Raise to Debug to show additional messages, or lower to None to ignore all
        // Extensive adds on top of Debug the internal messaging logs between background & UI
        this.logThreshold = LogLevel.Normal;
      }
      log(error, level) {
        // Set the default to Normal for backwards compatibility
        level = level || LogLevel.Normal;
        // If we area below the current threshold then return
        if (this.logThreshold === LogLevel.None || this.logThreshold < level) {
          return;
        }
        // TODO: BC - How should we handle errors?
        // Should likely use a logging packackage here to send errors to the user or backend logging.
        try {
          console.log(error);
        } catch (_a) {
          // If we failed above, just try one more time with a stringify in case JSON was sent
          console.log(JSON.stringify(error));
        }
      }
    }
    const logging = new Logging();
    /* harmony default export */ const src_logging =
      /* unused pure expression or super */ null && logging; // CONCATENATED MODULE: ./src/fn/router.ts

    // The Router routes messages sent to the dApp back to the extension.
    //
    // By default we are routing every message from the Extension to a global handler.
    // This handler bounces back a signal to the Extension as simple ACK mechanism, that will
    // ultimately resolve the Promise in the Extension side.
    //
    // In the future, we obviously want to offer more configuration. 2nd iteration probably adding
    // a dApp defined custom global handler, subsequent iterations probably be able of adding
    // custom handler for different message types, etc..

    class Router {
      constructor() {
        this.handler = this.default;
        window.addEventListener("message", (event) => {
          logging.log("Router DApp message event:", LogLevel.Extensive);
          logging.log(event, LogLevel.Extensive);
          const d = event.data;
          try {
            if (typeof d === "string") {
              const result = JSON.parse(d);
              const type = Object.prototype.toString.call(result);
              if (type === "[object Object]" || type === "[object Array]") {
                // We can display message output here, but as a string object it doesn't match our format and is likely from other sources
              }
            } else {
              if (
                Object.prototype.toString.call(d) === "[object Object]" &&
                "source" in d
              ) {
                if (d.source == MessageSource.Extension) {
                  d.source = MessageSource.Router;
                  d.origin = window.location.origin;
                  this.handler(d);
                }
              }
            }
          } catch (_a) {
            //console.log(`Unable to determine source from message. \nEvent:${JSON.stringify(event)}`);
          }
        });
      }
      default(d) {
        if (d.body.method in Task.subscriptions) {
          Task.subscriptions[d.body.method]();
        }
        this.bounce(d);
      }
      bounce(d) {
        const api = new MessageApi();
        window.postMessage(d, window.location.origin, [api.mc.port2]);
      }
    } // CONCATENATED MODULE: ../common/src/encoding.ts

    function base64ToByteArray(blob) {
      return stringToByteArray(atob(blob));
    }
    function byteArrayToBase64(array) {
      return btoa(byteArrayToString(array));
    }
    function stringToByteArray(str) {
      return new Uint8Array(str.split("").map((x) => x.charCodeAt(0)));
    }
    function byteArrayToString(array) {
      return String.fromCharCode.apply(null, array);
    } // CONCATENATED MODULE: ./src/algosigner.ts

    class Wrapper {
      constructor() {
        this.task = new Task();
        this.router = new Router();
        this.encoding = {
          msgpackToBase64: byteArrayToBase64,
          base64ToMsgpack: base64ToByteArray,
          stringToByteArray: stringToByteArray,
          byteArrayToString: byteArrayToString,
        };
        this.connect = this.task.connect;
        this.send = this.task.send;
        this.accounts = this.task.accounts;
        this.algod = this.task.algod;
        this.indexer = this.task.indexer;
        this.subscribe = this.task.subscribe;
        this.signTxn = this.task.signTxn;
      }
      static getInstance() {
        if (!Wrapper.instance) {
          Wrapper.instance = new Wrapper();
        }
        return Wrapper.instance;
      }
    }
    const AlgoSigner = Wrapper.getInstance(); // CONCATENATED MODULE: ./src/algorand.ts

    class algorand_Wrapper {
      constructor() {
        this.task = new Task();
        this.router = new Router();
        this.encoding = {
          msgpackToBase64: byteArrayToBase64,
          base64ToMsgpack: base64ToByteArray,
          stringToByteArray: stringToByteArray,
          byteArrayToString: byteArrayToString,
        };
        this.enable = this.task.enable;
        this.signAndPostTxns = this.task.signAndPostTxns;
        // public getAlgodv2Client: Function = this.task.algod;
        // public getIndexerClient: Function = this.task.indexer;
        this.signTxns = this.task.signTxns;
        this.postTxns = this.task.postTxns;
      }
      static getInstance() {
        if (!algorand_Wrapper.instance) {
          algorand_Wrapper.instance = new algorand_Wrapper();
        }
        return algorand_Wrapper.instance;
      }
    }
    const algorand = algorand_Wrapper.getInstance(); // CONCATENATED MODULE: ./src/index.ts

    /******/ return __webpack_exports__;
    /******/
  })();
});
